import { render } from "./PrlHospital.vue?vue&type=template&id=37b2a775&scoped=true"
import script from "./PrlHospital.vue?vue&type=script&lang=js"
export * from "./PrlHospital.vue?vue&type=script&lang=js"

import "./PrlHospital.vue?vue&type=style&index=0&id=37b2a775&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b2a775"]])

export default __exports__